import React from 'react'
import { BetCard } from '@mobi/betslip/Components/Common/BetCard'
import { colors } from '@mobi/component-library/Foundations'
import { Icon } from '@mobi/component-library/Legacy/Icon'
import type { Ticket, TicketStatus } from '@core/Areas/Account/Pages/Activity/types'
import type { BetLoopShareTicket } from '@core/Areas/BetLoop/types'
import { CountdownStatus } from '../Common/CountdownStatus'

export const Tipping: React.FC<{ ticket: Ticket | BetLoopShareTicket; status: TicketStatus }> = ({
  ticket,
  status,
}) => {
  const numberOfGames = ticket.legs.length
  return (
    <>
      <BetCard.EventDetails
        heading={`${numberOfGames} Game${numberOfGames > 1 ? 's' : ''}`}
        statusComponent={<CountdownStatus ticket={ticket} status={status} />}
        iconComponent={<Icon size='1.6rem' type='TIPPING' />}
      />

      <BetCard.SelectionInfo
        heading={ticket.shortProductName}
        subHeading={ticket.detailHeader}
        iconComponent={<Icon size='2.4rem' type='TIPPING' color={colors.neutral[800]} />}
      />
    </>
  )
}
